const escapeCharacter = {
    doubleQuote: '"',
    backslash: '\\'
};

export default escapeCharacter;
